import React from "react";
import "./AdminReportsummaryCards.css";

/**
 * @param {number} totalSubmitted
 * @param {number} totalRecruiters
 * @param {number} totalNotSubmitted
 */
function AdminReportSummaryCards({
  totalSubmitted,
  totalRecruiters,
  totalNotSubmitted,
}) {
  const submitted = totalSubmitted || 0;
  const recruiters = totalRecruiters || 0;
  const pending = totalNotSubmitted || 0;

  const cards = [
    {
      key: "active",
      label: "Total Users",
      value: recruiters,
      subtitle: "Registered in the system",
      iconBg: "#e0e7ff",
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <circle cx="9" cy="8" r="3" stroke="#4f46e5" strokeWidth="2" />
          <path
            d="M3 20c0-3.3 2.7-6 6-6s6 2.7 6 6"
            stroke="#4f46e5"
            strokeWidth="2"
            strokeLinecap="round"
          />
          <circle cx="17.5" cy="9" r="2.5" stroke="#4f46e5" strokeWidth="1.8" />
          <path
            d="M15.5 20c0-2.4 1-4.4 2.8-5.4"
            stroke="#4f46e5"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      ),
    },
    {
      key: "submitted",
      label: "Submitted Reports",
      value: submitted,
      subtitle: `Out of ${recruiters} users present`,
      iconBg: "#dcfce7",
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <rect
            x="5"
            y="3"
            width="14"
            height="18"
            rx="2"
            stroke="#16a34a"
            strokeWidth="2"
          />
          <path d="M9 3h6v2H9z" fill="#16a34a" />
          <path
            d="M9 12.5l2 2 4-4.5"
            stroke="#16a34a"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },

    {
      key: "pending",
      label: "Pending Reports",
      value: pending,
      subtitle: "Awaiting submission",
      iconBg: "#fee2e2",
      icon: (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <rect
            x="5"
            y="3"
            width="14"
            height="18"
            rx="2"
            stroke="#dc2626"
            strokeWidth="2"
          />
          <path d="M9 3h6v2H9z" fill="#dc2626" />
          <circle
            cx="17"
            cy="16"
            r="5"
            fill="#fff"
            stroke="#dc2626"
            strokeWidth="1.5"
          />
          <path
            d="M17 13.6v2.4l1.4 1"
            stroke="#dc2626"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ),
    },
  ];

  return (
    <div className="admin-report-summary-cards">
      {cards.map((card) => (
        <div className="admin-report-summary-card" key={card.key}>
          <div className="admin-report-summary-card__top">
            <span className="admin-report-summary-card__label">
              {card.label}
            </span>
            <span
              className="admin-report-summary-card__icon"
              style={{ background: card.iconBg }}
            >
              {card.icon}
            </span>
          </div>
          <div className="admin-report-summary-card__value">{card.value}</div>
          <div className="admin-report-summary-card__subtitle">
            {card.subtitle}
          </div>
        </div>
      ))}
    </div>
  );
}

export default AdminReportSummaryCards;
